import { Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { FC, useCallback } from 'react';

const DatePicker: FC<React.PropsWithChildren<DatePickerProps>> = ({
  title,
  date,
  setDate,
  minDateTime,
  maxDateTime,
  setDateChanged,
}) => {
  const onChange = useCallback(
    (newValue: dayjs.Dayjs | null) => {
      setDate(newValue);
      setDateChanged(true);
    },
    [setDate, setDateChanged],
  );

  const onKeyDown = e => {
    e.preventDefault();
  };

  return (
    <div>
      <Typography mb={0.5} color='text.primary'>
        {title}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          value={date}
          onChange={onChange}
          disableFuture
          minDateTime={minDateTime ? minDateTime : undefined}
          maxDateTime={maxDateTime ? maxDateTime : undefined}
          renderInput={params => (
            <TextField {...params} onKeyDown={onKeyDown} />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export interface DatePickerProps {
  title: string;
  date: dayjs.Dayjs | null;
  // setDate: React.Dispatch<React.SetStateAction<dayjs.Dayjs | null>>;
  setDate: (date: dayjs.Dayjs | null) => void;
  minDateTime?: dayjs.Dayjs | null;
  maxDateTime?: dayjs.Dayjs | null;
  setDateChanged: React.Dispatch<React.SetStateAction<boolean>>;
}

export default DatePicker;
